import axios from "axios";
import APIS from "./api";
import { GetLocalStorage } from "../utils/local-storage";

export const RequestRefreshToken = async () => {
  let data:any =GetLocalStorage("loginData"); 
  axios.interceptors.request.use((request) => {
    return request;
  });

  axios.defaults.headers.common["refreshToken"] = data.refreshToken;
  const param = {};
  return new Promise(function (resolve, reject) {
    axios
      .post(APIS.REFRESH_TOKEN, param)
      .then(async (res: any) => {
        if (res.data.isSuccess) {
          let data = res.data.result;
          await localStorage.clear();
          resolve(res.data);
        } else {
          await localStorage.clear();
          window.location.href = "/home";
          reject(res);
        }
      })
      .catch(async (e: any) => {
        reject(e);
      });
  });
};
